import get from 'lodash.get';
import { CartTypeQuery } from '../cart';

const getCartId = (client) =>
  client
    .query({
      query: CartTypeQuery,
    })
    .then((response) => get(response, 'data.user.cart.id'));

export default getCartId;
